import React from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import Switches from '../../../../../components/fields/Switches/Switches';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../../configs';
import { infoFormatterIntl } from '../../../../../utils/formatters';
import FileView from '../../../../../components/fields/FileInput/FileView';

export default function ReorganizationJuridicalForm(props) {
  const {
    fieldsValidation = {}, applicantType, procedure, currentApplication, isEdit,
  } = props;

  const applicant_new = currentApplication?.applicant_new || {};
  const files = currentApplication?.files || [];
  const registry_subject = currentApplication?.registry_subject || {};
  const {
    full_name: oldFullName,
    short_name: oldShortName,
    ogrn: oldOgrn,
    inn: oldInnName,
    address: oldAddress,
    legal_address: oldLegalAddress,
  } = registry_subject;
  const {
    address, legal_address, inn, ogrn, short_name, full_name, legal_entity_form,
  } = applicant_new;

  const identity_change_document = files.find(item => item.collection_name === 'identity_change_document');

  return [PROCEDURE_TYPE.PROCEDURE_1227_3, PROCEDURE_TYPE.PROCEDURE_1227_5, PROCEDURE_TYPE.PROCEDURE_1227_8, PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure) && applicantType === USER_TYPE.LEGAL ? (
    <>
      {![PROCEDURE_TYPE.PROCEDURE_1227_8].includes(procedure) && (<div className="f3 mt-3">Реорганизация юридического лица</div>)}
      {[PROCEDURE_TYPE.PROCEDURE_1227_3, PROCEDURE_TYPE.PROCEDURE_1227_8, PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure) && (
        <>
          <div className="f4 mt-3">Изменилось полное и сокращенное (при наличии) наименование (на русском языке)</div>
          {![PROCEDURE_TYPE.PROCEDURE_1227_8].includes(procedure) && (
          <Row className="row-cols-1">
            {infoFormatterIntl('new.legal_entity_form', legal_entity_form, fieldsValidation, 'application_order_service_new.legal_entity_form')}
          </Row>
          )}
          <Row className="row-cols-1">
            <Col>
              <Switches
                type="text"
                variant="material"
                inputProps={{
                  onChange: () => {},
                  value: !!full_name || full_name === null,
                }}
                label="Изменилось полное наименование (на русском языке)"
              />
            </Col>
          </Row>
          {(!!full_name || full_name === null) && (
          <>
            <Row className="row-cols-1">
              {infoFormatterIntl('old.full_name_legal', oldFullName, fieldsValidation, 'full_name')}
            </Row>
            <Row className="row-cols-1">
              {infoFormatterIntl('new.full_name_legal', full_name, fieldsValidation, 'applicant_new.full_name')}
            </Row>
          </>
          )}
          <Row className="row-cols-1">
            <Col>
              <Switches
                type="text"
                variant="material"
                inputProps={{
                  onChange: () => {},
                  value: !!short_name || short_name === null,
                }}
                label="Изменилось сокращённое наименование (на русском языке)"
              />
            </Col>
          </Row>
          {(!!short_name || short_name === null) && (
          <>
            <Row className="row-cols-1">
              {infoFormatterIntl('old.short_name_legal', oldShortName, fieldsValidation, 'short_name')}
            </Row>
            <Row className="row-cols-1">
              {infoFormatterIntl('new.short_name_legal', short_name, fieldsValidation, 'applicant_new.short_name')}
            </Row>
          </>
          )}
        </>
      )}
      {[PROCEDURE_TYPE.PROCEDURE_1227_3, PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure) && (
        <>
          <div className="f4 mt-3">Изменился ИНН и/или ОГРН</div>
          <Row className="row-cols-1">
            <Col>
              <Switches
                type="text"
                variant="material"
                inputProps={{
                  onChange: () => {},
                  value: !!inn || inn === null,
                }}
                label="Изменился ИНН"
              />
            </Col>
          </Row>
          {(!!inn || inn === null) && (
          <>
            <Row className="row-cols-1">
              {infoFormatterIntl('old.inn', oldInnName, fieldsValidation, 'inn')}
            </Row>
            <Row className="row-cols-1">
              {infoFormatterIntl('new.inn', inn, fieldsValidation, 'applicant_new.inn')}
            </Row>
          </>
          )}
          <Row className="row-cols-1">
            <Col>
              <Switches
                type="text"
                variant="material"
                inputProps={{
                  onChange: () => {},
                  value: !!ogrn || ogrn === null,
                }}
                label="Изменился ОГРН"
              />
            </Col>
          </Row>
          {(!!ogrn || ogrn === null) && (
          <>
            <Row className="row-cols-1">
              {infoFormatterIntl('old.ogrn', oldOgrn, fieldsValidation, 'ogrn')}
            </Row>
            <Row className="row-cols-1">
              {infoFormatterIntl('new.ogrn', ogrn, fieldsValidation, 'applicant_new.ogrn')}
            </Row>
          </>
          )}
        </>
      )}
      <div className="f4 mt-3">Изменился юридический адрес и/или адрес местонахождения</div>
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: !!legal_address || legal_address === null,
            }}
            label="Изменился юридический адрес"
          />
        </Col>
      </Row>
      {(!!legal_address || legal_address === null) && (
      <>
        <Row className="row-cols-1">
          {infoFormatterIntl('old.legal_address', oldLegalAddress, fieldsValidation, 'legal_address')}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('new.legal_address', legal_address, fieldsValidation, 'applicant_new.legal_address')}
        </Row>
      </>
      )}
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: !!address || address === null,
            }}
            label="Изменился адрес местонахождения"
          />
        </Col>
      </Row>
      {(!!address || address === null) && (
      <>
        <Row className="row-cols-1">
          {infoFormatterIntl('old.address_location', oldAddress, fieldsValidation, 'address')}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('new.address_location', address, fieldsValidation, 'applicant_new.address')}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('media.identity_change_document', identity_change_document ? <FileView readOnly withoutMime withoutHr files={[identity_change_document]} /> : null, fieldsValidation, '', 6)}
        </Row>
      </>
      )}
      <div className="hr-row mt-3" />
    </>
  ) : null;
}
